import { breakpoints } from 'style'

const { default: styled } = require('styled-components')

const PromptOrderContainer = styled.div`
  .max-height: 100%;

  .prompts-list {
    overflow: hidden;

    @media (min-width: ${breakpoints.desktop}px) {
      max-height: 600px;
      overflow-y: auto;

      @media (min-height: 1100px) {
        max-height: 800px;
      }
      @media (min-height: 1200px) {
        max-height: 920px;
      }
    }
  }
  .prompt-item {
    padding: 1rem;

    .desktop {
      display: flex;
      width: 100%;
      -webkit-box-pack: start;
      justify-content: flex-start;
      -webkit-box-align: center;
      align-items: center;
      cursor: pointer;
    }

    .mobile {
      display: flex;
      flex-direction: column;
      width: 100%;
      -webkit-box-pack: start;
      justify-content: flex-start;
      -webkit-box-align: center;
      align-items: center;
      cursor: pointer;
      min-height: 70px;
    }

    @media (max-width: ${breakpoints.sm}px) {
      .desktop {
        display: none;
      }
    }
    @media (min-width: ${breakpoints.sm}px) {
      .mobile {
        display: none;
      }
    }
  }

  .cancel {
    margin-right: 1rem;
  }

  .modal-footer {
    border-top: none;
  }
`

export default PromptOrderContainer
